const HomePage = () => (
  <div>
    <h1 className="font-dbh">HomePage</h1>
  </div>
);

export default HomePage;
